/** URL segment for /site/:slug and /similar/:slug (matches server). */
export function sitePathSlug(site) {
  if (!site) return '';
  const s = site.slug || String(site.domain || '').replace(/\./g, '-');
  return String(s).toLowerCase().replace(/[^a-z0-9-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '') || 'site';
}
